module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.624/css/toolsmenu.css"